import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { AddToBagLayoutEnum } from '@inter-ikea-kompis/component-add-to-bag';
import { ImageSizeTypeEnum } from '@inter-ikea-kompis/enums';
import { KompisPriceModule } from '@inter-ikea-kompis/react-components';
import styled from 'styled-components';
import { SkapaColors, SkapaText, SkapaTokens } from '@inter-ikea-guida/skapa';
import { typographyHelper } from '@inter-ikea-guida/utils';
import { GuidaImage } from '../../GuidaImage';
import { GuidaCompactTextWrapper } from '../../typography/GuidaCompactTextWrapper';
const StyledCtaWrapper = styled.div `
  margin-top: ${SkapaTokens.space100};
`;
const StyledGridItem = styled.div `
  position: relative;
  grid-row: ${props => props.$row};
  grid-column: ${props => `${props.$columns[0]}/${props.$columns[1]}`};

  margin-top: ${props => (props.$row % 2 === 0 ? SkapaTokens.space50 : 0)};
  margin-bottom: ${props => (props.$row % 2 === 0 ? SkapaTokens.space200 : 0)};
`;
const StyledImageLabel = styled.div `
  position: absolute;
  top: 0;
  left: 0;
  color: ${SkapaColors.colourStaticWhite};
  background-color: ${SkapaColors.colourStaticDarkGrey};
  padding: 6px;
  font-size: ${SkapaTokens.fontSize50};
  font-weight: ${SkapaTokens.fontWeightBold};
  max-width: 75%;
  text-align: left;
`;
const StyledPriceModuleWrapper = styled.div `
  margin-top: ${SkapaTokens.space50};
`;
export const UpsellProductItem = ({ product, translations, dexfSettings, theme, AddToBagButton, onAdd, index, isMetric }) => {
    const row = index % 2 == 0 ? index + 1 : index;
    const columns = index % 2 === 0 ? [1, 3] : [3, 5];
    const productImage = product.productData.content?.image?.find(image => image.typeName === product.imageType && image.size === ImageSizeTypeEnum.S3)?.url;
    const productName = product.quantity > 1
        ? `${product.quantity} × ${product.productData.content?.name}`
        : product.productData.content?.name;
    return (_jsxs(_Fragment, { children: [_jsxs(StyledGridItem, { "$row": row, "$columns": columns, children: [_jsxs("div", { children: [productImage && (_jsx(GuidaImage, { src: productImage, alt: '', enableSkeleton: true, aspectRatio: '1/1' })), _jsx(StyledPriceModuleWrapper, { children: _jsxs(KompisPriceModule, { shoppingProducts: [
                                        {
                                            product: product.productData,
                                            quantity: product.quantity
                                        }
                                    ], productName: productName, settings: dexfSettings, translations: translations, theme: theme, showLowestPreviousSalesPrice: true, children: [typographyHelper.capitalizeFirstLetter(product.productData.content?.typeName ?? ''), ",", ' ', isMetric
                                            ? product.productData.content?.measureReference?.textMetric
                                            : product.productData.content?.measureReference?.textImperial] }) })] }), product.imageLabel && _jsx(StyledImageLabel, { children: product.imageLabel })] }), _jsxs(StyledGridItem, { "$row": row + 1, "$columns": columns, children: [product.subtitle && (_jsx(GuidaCompactTextWrapper, { children: _jsx(SkapaText, { tagName: 'h4', children: product.subtitle }) })), product.description && (_jsx(GuidaCompactTextWrapper, { children: _jsx(SkapaText, { tagName: 'p', children: product.description }) })), _jsx(StyledCtaWrapper, { children: _jsx(AddToBagButton, { layout: AddToBagLayoutEnum.icon, onAdd: onAdd, product: product.productData, quantity: product.quantity }) })] })] }));
};
//# sourceMappingURL=UpsellProductItem.js.map